var api = require("!../../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../../css-loader/dist/cjs.js!../../../../virtual-resource-loader/dist/virtual-resource-loader.cjs.js?{\"source\":\"LmJlbXQxcDAgewogIGNvbG9yOiAjNWY1ZjVmOwogIGZvbnQtc2l6ZTogMTRweDsKICBtYXJnaW46IDVweCAwIDAgMDsKfQ==\"}!./vanilla-extract-webpack-plugin-extracted.cjs.js");

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.id, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};